export default __webpack_public_path__ + "static/85-d7f12cd6023a41bbcd364998c16d193d.png";